import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Button from "@material-ui/core/Button";

import DialogTitle from "../DialogTitle";
import type Step from "../Step";

interface OtherDoYouSellProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

type Options = "yes" | "no";

const useStyles = makeStyles((theme) => ({
  content: {
    margin: "auto",
  },
  radioGroup: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
}));

function OtherDoYouSell({ onClose, onStepChange }: OtherDoYouSellProps) {
  const classes = useStyles();
  const [value, setValue] = useState<Options>();

  return (
    <>
      <DialogTitle onClose={onClose}>Set Up Questions - 6/9</DialogTitle>
      <MuiDialogContent className={classes.content}>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            Would you like to upload data from other platforms?
          </FormLabel>
          <RadioGroup
            value={value || null}
            onChange={(event) => {
              setValue((event.target as HTMLInputElement).value as Options);
            }}
            className={classes.radioGroup}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel
              value="no"
              control={<Radio />}
              label="No data to upload / I'll enter manually"
            />
          </RadioGroup>
        </FormControl>
      </MuiDialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onStepChange("whatnot:do-you-sell-on-whatnot");
          }}
          color="primary"
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          disabled={!value}
          onClick={() => {
            onStepChange(
              value === "yes"
                ? "other:upload"
                : "plaid:would-you-like-to-connect"
            );
          }}
          color="primary"
          autoFocus
        >
          Next
        </Button>
      </DialogActions>
    </>
  );
}

export default OtherDoYouSell;
